import React, { HTMLAttributes, useEffect, useRef } from 'react';
import styled from 'styled-components';

import { useCurrentUserData } from '@pass-frontend/common/data-bridge';
import { uhcTheme, rallyTheme } from '@pass-frontend/common/util/theme-config';
import { RdsIcon } from '@pass-frontend/rally-energon-react';
import { MEDIA_QUERY, getRDSColor } from '@pass-frontend/utility/style-helpers';

const StyledButton = styled.button<{ color: string }>`
  z-index: 2;
  background: white;
  border: #ccc solid 1px;
  border-radius: 50%;
  color: ${({ color }) => color};
  cursor: pointer;
  display: flex;
  padding: 11px;
  position: absolute;
  right: 32px;
  top: 32px;

  ${MEDIA_QUERY.mobile} {
    right: 16px;
    top: 16px;
  }
`;

const ModalCloseButton = (props: HTMLAttributes<HTMLButtonElement>) => {
  const { isRenewActive } = useCurrentUserData();
  const btnRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    btnRef.current?.focus();
  }, []);

  return (
    <StyledButton
      ref={btnRef}
      className="Modal-iconButton close-btn"
      data-testid="close-btn"
      data-ui-element-name="close-button"
      color={
        isRenewActive
          ? getRDSColor('brandColor')({ theme: uhcTheme })
          : getRDSColor('primaryColor')({ theme: rallyTheme })
      }
      {...props}
    >
      <RdsIcon name="system-close" size="16" />
    </StyledButton>
  );
};

export default ModalCloseButton;
